import { AdminUserServices } from '@/services/admin.user.services'

const state = {
  dialogUserdetail: false,
  loading: false,
  dialog: false,
  overlay: false,
  adminuser: [],
  totaladminuser: 0,
  sellerreq: [],
  totalsellerreq: 0,
  roles: [],
  userdetail: {
    user: {
      confm: 0,
      id: 0
    },
    member: {

    }
  },
  sumuser: {
    totaluser: 0,
    totalseller: 0,
    totalreqseller: 0
  }
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialoguserdetail ({ commit }, diag) {
    commit('setdialoguserdetail', diag)
  },
  getSumUser ({ dispatch, commit }) {
    commit('setloading', true)
    AdminUserServices.getSumUser().then(value => {
      commit('setloading', false)
      commit('setsumuser', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  approveSeller ({ dispatch, commit }, id) {
    commit('setloading', true)
    AdminUserServices.approveSeller(id).then(value => {
      commit('setloading', false)
      commit('setdialoguserdetail', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  rejectSeller ({ dispatch, commit }, id) {
    commit('setloading', true)
    AdminUserServices.rejectSeller(id).then(value => {
      commit('setloading', false)
      commit('setdialoguserdetail', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  resendemailAct ({ dispatch, commit }, id) {
    commit('setloading', true)
    AdminUserServices.resendemailAct(id).then(value => {
      commit('setloading', false)
      commit('setdialoguserdetail', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  adminUpdateStatusToko ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminUserServices.updateAdminStatusToko(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      var id = localStorage.getItem('iduserdetail')
      AdminUserServices.getUserDetail(id).then(value => {
        commit('setloading', false)
        commit('setUserDetail', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  deleteRole ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminUserServices.deleteRole(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      var id = localStorage.getItem('iduserdetail')
      AdminUserServices.getUserDetail(id).then(value => {
        commit('setloading', false)
        commit('setUserDetail', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getRoles ({ dispatch, commit }) {
    commit('setloading', true)
    AdminUserServices.getRoles().then(value => {
      commit('setloading', false)
      commit('setRoles', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addUserRole ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminUserServices.addRoles(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      var id = localStorage.getItem('iduserdetail')
      AdminUserServices.getUserDetail(id).then(value => {
        commit('setloading', false)
        commit('setUserDetail', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getAllUsers ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminUserServices.getALlUser(opt).then(value => {
      commit('setloading', false)
      commit('setdataadminuser', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getSellerReq ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminUserServices.getSellerReq(opt).then(value => {
      commit('setloading', false)
      commit('setdataadminsellerreq', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getUserDetail ({ dispatch, commit }, id) {
    commit('setloading', true)
    localStorage.setItem('iduserdetail', id)
    AdminUserServices.getUserDetail(id).then(value => {
      commit('setloading', false)
      commit('setUserDetail', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateUser ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminUserServices.updateUser(data).then(value => {
      commit('setloading', false)
      commit('setdialoguserdetail', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialoguserdetail (state, s) {
    state.dialogUserdetail = s
  },
  setdataadminuser (state, s) {
    state.adminuser = []
    state.adminuser = s.data.content
    state.totaladminuser = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdataadminsellerreq (state, s) {
    state.sellerreq = []
    state.sellerreq = s.data.content
    state.totalsellerreq = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setRoles (state, s) {
    state.roles = []
    state.roles = s.data
  },
  setUserDetail (state, s) {
    state.userdetail = {}
    state.userdetail = s.data
  },
  setsumuser (state, s) {
    state.sumuser = s.data
  }
}

export const AdminUserStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
